import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import React from 'react';
import TrueLinkTextInput from 'react/shared/components/true_link/main/form/text_input/TrueLinkTextInput';
import { getNestedValue } from 'react/shared/utils/Objects';

const getInputDivStyles = () => ({
  marginBottom: '0px',
  width: '135px',
  '& .MuiInput-root': {
    '& input': {
      height: '42px',
      marginBottom: 0,
      '&::placeholder': {
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '14px',
      },
    },
  },
  '& > div': {
    marginBottom: '0px',
  },
});

export default function PlainTextFilter({
  column: { setFilter, filterValue = '', getFilterProps },
}) {
  const filterProps = getFilterProps ? getFilterProps() : {};
  const placeholder = filterProps?.placeholder || 'Search';

  const handleBlur = (e) => {
    setFilter(e.target.value);
  };

  return (
    <Box sx={getInputDivStyles()}>
      <TrueLinkTextInput
        isFormik={false}
        onChange={handleBlur}
        placeholder={placeholder}
        size="small"
        value={filterValue}
      />
    </Box>
  );
}

PlainTextFilter.defaultFilterFn = (rows, accessors, filterValue) =>
  rows.filter((row) => {
    if (filterValue === '') {
      return true;
    }
    const rowValue = getNestedValue(row.original, accessors[0]) ?? '';

    if (rowValue === '') {
      return false;
    }
    const searchValue = filterValue.toLowerCase();
    return rowValue.toLowerCase().includes(searchValue);
  });

PlainTextFilter.propTypes = {
  column: PropTypes.shape({
    filterValue: PropTypes.string,
    preFilteredRows: PropTypes.array,
    setFilter: PropTypes.func,
    id: PropTypes.string,
    getFilterProps: PropTypes.func,
  }),
};
